import { render, staticRenderFns } from "./CasePopup.vue?vue&type=template&id=27f70496&"
import script from "./CasePopup.vue?vue&type=script&lang=ts&"
export * from "./CasePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports